import { api } from "../lib/api";

export const dashboard = (params = {}) =>
  api.get("/acquisition/dashboard", { params }).then((response) => response.data);

export const listLeads = (params = {}) =>
  api.get("/acquisition/leads", { params }).then((response) => response.data);

export const getLead = (id) =>
  api.get(`/acquisition/leads/${encodeURIComponent(id)}`).then((response) => response.data);

export const createLead = (payload) =>
  api.post("/acquisition/leads", payload).then((response) => response.data);

export const assignLead = (id, assignedUserId) =>
  api
    .post(`/acquisition/leads/${encodeURIComponent(id)}/assignment`, {
      assignedUserId,
    })
    .then((response) => response.data);

export const resolveDuplicate = (id, payload) =>
  api
    .post(
      `/acquisition/leads/${encodeURIComponent(id)}/duplicate-resolution`,
      payload
    )
    .then((response) => response.data);

export const rejectLead = (id, reason) =>
  api
    .post(`/acquisition/leads/${encodeURIComponent(id)}/reject`, { reason })
    .then((response) => response.data);

export const listSources = () =>
  api.get("/acquisition/sources").then((response) => response.data);

export const saveSource = (payload) =>
  api.post("/acquisition/sources", payload).then((response) => response.data);

export const listCampaigns = () =>
  api.get("/acquisition/campaigns").then((response) => response.data);

export const listConnections = () =>
  api.get("/acquisition/connections").then((response) => response.data);


export const importLeads = (sourceId, rows) =>
  api
    .post("/acquisition/leads/import", { sourceId, rows })
    .then((response) => response.data);

export const metaConfiguration = () =>
  api
    .get("/acquisition/connections/meta/configuration")
    .then((response) => response.data);

export const metaOauthUrl = () =>
  api
    .get("/acquisition/connections/meta/oauth-url")
    .then((response) => response.data);

export const disconnectMeta = () =>
  api
    .post("/acquisition/connections/meta/disconnect")
    .then((response) => response.data);


export const syncMeta = () =>
  api
    .post("/acquisition/connections/meta/sync")
    .then((response) => response.data);


export const getCampaign = (id) =>
  api
    .get(`/acquisition/campaigns/${encodeURIComponent(id)}`)
    .then((response) => response.data);

export const retentionStatus = (execute = false) =>
  api
    .post("/acquisition/privacy/retention", { execute })
    .then((response) => response.data);

export const anonymizeLead = (id, payload = {}) =>
  api
    .post(
      `/acquisition/leads/${encodeURIComponent(id)}/privacy/anonymize`,
      payload
    )
    .then((response) => response.data);


export const testMeta = () =>
  api
    .post("/acquisition/connections/meta/test")
    .then((response) => response.data);
